module.exports = __webpack_public_path__ + "assets/img/s3-tab-1-active-95790b61.png";